import agent from 'local/test/agent';

const settings = window.bredbandskollen;

export default function configure(m) {
	const { iptype, configuration, hashkey } = m.data;

	agent.send({
		method: 'setConfigurationOption',
		args: {
			'Measure.IpType': iptype,
			'Logging.LogToConsole': window.bredbandskollen.debug,
			'Client.key': hashkey,
			'Client.host': settings.backend,
			'Client.appname': settings.appname,
			'Client.appver': settings.appver,
			'Client.debugtag':
				settings.debugTag && settings.debugTag.length
					? settings.debugTag
					: null,
			'Client.protocol': 'https',
			Protocol: 'https',
		},
	});

	if (hashkey) {
		agent.send({
			method: 'saveConfigurationOption',
			args: {
				'Client.hashkey': hashkey,
			},
		});
	}

	if (!configuration) {
		agent.send({ method: 'getConfiguration' });
	} else if (m.data.startRequested) {
		m.dispatch('start');
	}
}
